export default "__VITE_ASSET__8531f37a__"